// removed by extract-text-webpack-plugin
module.exports = {"title":"_8b37U1sZi _2OFXNnC9U _2ytTHqVtN _2xBlx7GXb _27psO4Sjy y4wLu1mD3"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/title/title.css
 ** module id = 2180
 ** module chunks = 0
 **/